<template>
    <div v-show="loginShow" class="login_mask">
        <div class="login_content">
            <div class="login_tit"></div>
            <div class="login_close" @click.self="closeLoginBox"></div>
            <div class="login_box">
                <!-- <div class="login_item login_item_name">
                    <input type="text" id="name" v-model="form.name" placeholder="请输入您的姓名">
                </div> -->
                <div class="login_item login_item_tel">
                    <input type="tel" autocomplete="off" maxlength="11" id="tel" v-model.lazy.trim="form.tel" placeholder="请输入您的手机号码">
                </div>
                <div class="login_item login_item_tpyzm">
                    <div class="login_yzm">
                        <input type="tel" maxlength="4" autocomplete="off" id="tpyzm" v-model.lazy.trim="form.tpyzm" placeholder="请输入图片验证码">
                    </div>
                    <div class="login_tpyzm" @click.stop="changeYzm">
                        <img :src="tpyzm_url" alt="">    
                    </div>
                    
                </div>
                <div class="login_item">
                    <div class="login_yzm">
                        <input  type="tel" autocomplete="off" maxlength="6" id="sjyzm" v-model.lazy.trim="form.sjyzm" placeholder="请输入验证码">
                    </div>
                    <div v-if="countdown.finish" @click.self="getYzm" class="login_getyzm">获取验证码</div>
                    <div v-else class="login_getyzm">
                        重新获取(<van-count-down
                        ref="countDown"
                        millisecond
                        :time="60000"
                        :auto-start="false"
                        format="ss"
                        @finish="countdownFinish"
                        />s)
                    </div>
                    
                </div>
                <div class="login_submit" @click.self="login_submit">登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import { CountDown } from "vant";

import { imageVerifyCodeUrl,verifyCode,login} from '@/service/user';
// import { addInvite } from '@/service/activity/brandWeek'
import BrandWeekStore from '@/store/modules/brandWeek';
export default {
    components: {
        "van-count-down": CountDown,
    },
    // emits:["onLogined","onLoginBoxClose"],
    data() {
        return {
            loginShow:false,
            form:{
                // name:"",
                tel:"",
                tpyzm:"",
                sjyzm:""
            },
            tpyzm_url:"",
            countdown:{
                finish:true
            },
            // 登录成功监听器
            loginResultListener:null,
            flag_obj:{
                get_flag:true,
                submit_flag:true,
            }
        };
    },
    methods:{
        created(){
        },
        mounted(){
        },
        // 登录结果回调
        setLoginResultListener(listener){
            let that = this;
            if (listener){
                that.loginResultListener = listener;
            }
        },
        // 显示
        showLoginBox(listener){
            this.setLoginResultListener(listener);
            this.loginShow = true;
            this.changeYzm();
        },
        // 隐藏
        hideLoginBox(){
            this.form={
                tel:"",
                tpyzm:"",
                sjyzm:""
            }
            this.loginShow = false;
            this.tpyzm_url='';
        },
        // 用户关闭登录框
        closeLoginBox(){
            // const that = this;
            this.hideLoginBox()
            if (this.loginResultListener)
                this.loginResultListener(false);

            // that.$emit("onLoginBoxClose")
        },
        // 提交登录
        login_submit(){
            
            const that = this;
            if(that.flag_obj.submit_flag == false){
                return false;
            }else{
                that.flag_obj.submit_flag = false;
            }
            let {tel,tpyzm,sjyzm} = that.form;
            tel = tel.trim();
            if(!tel){
                that.$toast("请输入手机号！");
                that.flag_obj.submit_flag = true;
                return false;
            }
            if(!(/^1[3,4,5,6,7,8,9]\d{9}$/).test(tel)){
                that.$toast("请正确输入手机号！");
                that.flag_obj.submit_flag = true;
                return false;
            }
            if(tpyzm.length<4){
                that.$toast("请输入图片验证码！");
                that.flag_obj.submit_flag = true;
                return false;
            }
            if(sjyzm.length<4){
                that.$toast("请输入手机验证码！");
                that.flag_obj.submit_flag = true;
                return false;
            }
            login(tel,sjyzm).then(res=>{
                if(res.code !==200 ){
                    that.$toast(res.message);
                    that.flag_obj.submit_flag = true;
                    that.form.tpyzm="";
                    that.form.sjyzm="";
                    that.changeYzm();
                    // if (that.loginResultListener)
                    //     that.loginResultListener(false);
                }else{
                    // 设置session 数据，放代码段顶部
                    that.$session.update(res.data)
                    // 红包初始化

                    // 邀请关系记录和增加抽奖次数
                    // if (that.$session.inviterid)
                    //     addInvite(that.$session.inviterid)
                    // else
                    //     addInvite()

                    // 获取用户登录后相关数据
                    const hasResultListener = that.loginResultListener && that.loginResultListener instanceof Function;
                    // param1 有无结果处理监听器
                    // that.$emit("onLogined")

                    BrandWeekStore.userMethods.doShowCash(that.$session.inviterid,function(){
                        BrandWeekStore.userMethods.getUserActivityInfo(function(){
                            if (hasResultListener){
                                that.loginResultListener(true,res.data);
                                // 获取用户登录后相关数据
                            }
                            that.hideLoginBox();
                            that.flag_obj.submit_flag = true;
                        })
                    })
                }
            }).catch(()=>{
                that.flag_obj.submit_flag = true;
            })
        },
        changeYzm(){
            this.tpyzm_url = imageVerifyCodeUrl(this.$session);
        },
        getYzm(){
            const that = this;
            if(!that.flag_obj.get_flag){
                return false;
            }
            that.flag_obj.get_flag = false;
            let tel = that.form.tel;
            let tpyzm = that.form.tpyzm;
            tel = tel.trim();
            if(!tel){
                that.$toast("请输入手机号！");
                that.flag_obj.get_flag = true;
                return false;
            }
            if(!(/^1[3,4,5,6,7,8,9]\d{9}$/).test(tel)){
                that.$toast("请正确输入手机号！");
                that.flag_obj.get_flag = true;
                return false;
            }
            if(tpyzm.length<4){
                that.$toast("请输入图片验证码！");
                that.flag_obj.get_flag = true;
                return false;
            }
            verifyCode(that.$session,tel,tpyzm).then(res=>{
                if(res.code!==200){
                    that.$toast(res.message)
                    that.tpyzm_url = imageVerifyCodeUrl(that.$session);
                    that.flag_obj.get_flag = true;
                    that.countdown.finish=true;
                }else{
                    that.countdown.finish=false;
                    setTimeout(() => {
                        that.$refs.countDown.start();
                        this.flag_obj.get_flag = true;
                    }, 100);
                }
            }).catch(()=>{
                this.flag_obj.get_flag = true;
                that.countdown.finish=true;
            })
        },
        countdownFinish(){
            this.$refs.countDown.reset();
            this.countdown.finish = true;
        }
    },

 
}
</script>

<style scoped>
.login_mask{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 999;
}
.login_content{
    width: 710px;
    padding: 12px;
    border-radius: 20px;
    background:linear-gradient(to bottom,#fbd98e,#d674ff);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.login_box{
    background: #fff;
    border-radius: 10px;
    padding:108px 48px 88px 53px;
}
.login_tit{
    width: 612px;
    height: 239px;
    background: url(../../assets/images/brandWeek/login_tit.png) no-repeat;
    background-size: 100%;
    position: absolute;
    top: -92px;
    left: 83px;
}
.login_close{
    width: 72px;
    height: 72px;
    background: url(../../assets/images/brandWeek/login_close.png) no-repeat;
    background-size: 100%;
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
}
.login_item{
    width: 100%;
    height: 93px;
    border-radius: 46px;
    /* background: #f3f3f3; */
    margin-bottom: 27px;
    font-size: 28px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.login_item:last-child{
    margin-bottom: 0;
}
.login_submit{
    width: 585px;
    height: 93px;
    line-height: 94px;
    font-size: 36px;
    color: #fff;
    text-align: center;
    background: url(../../assets/images/brandWeek/login_btn.png) no-repeat;
    background-size: 100%;
}
.login_item input{
    width: 100%;
    height: 100%;
    border: none;
    background: #f3f3f3;
    color: #8b64c0;
    padding-left: 60px;   
}
.login_item_name input,.login_item_tel input{
    padding-left: 108px;
}
.login_item_name input{
    background: #f3f3f3 url(../../assets/images/brandWeek/icon-user.png) no-repeat left center;
    background-size: 29px 31px;
    background-position-x: 46px;
}
.login_item_tel input{
    background: #f3f3f3 url(../../assets/images/brandWeek/icon-phone.png) no-repeat left center;
    background-size: 24px 37px;
    background-position-x: 51px;
}
.login_item input::-webkit-input-placeholder { 
    color: #8b64c0;
}
.login_item input::-moz-placeholder { 
    color: #8b64c0;
} 
.login_item input:-ms-input-placeholder { 
    color: #8b64c0;
} 
.login_item input:-moz-placeholder { 
    color: #8b64c0;
}
.login_yzm{
    width: 334px;
    height: 100%;
    border-radius: 46px;
    overflow: hidden;
}
.login_tpyzm,.login_getyzm{
    width: 228px;
    height: 100%;
    line-height: 94px;
    text-align: center;
    color: #8b64c0;
    border-radius: 46px;
    overflow: hidden;
    background: #f3f3f3;
}
.login_getyzm .van-count-down{
    font-size: 28px;
}
.login_tpyzm{
    border-radius: 0;
}
.login_tpyzm img{
    width: 100%;
    height: 100%;
}
.login_item_tpyzm{
    border-radius: 46px 0 0 46px;
}

.van-count-down{
    display: inline;
}
</style>